import { RegistrationAction, RegistrationState } from '@/types/pages/storeManagement/registration/registrationTypes';
import { includes } from 'lodash';
import { defaultState } from './registrationInitialState';

export const reducer = (state: RegistrationState, action: RegistrationAction) => {
    switch (action.type) {
        case 'TOGGLE_LABEL_DISABLE':
            return {
                ...state,
                labelOptions: state.labelOptions.map((item) => ({
                    ...item,
                    disable: includes(action.payload.label, item.key),
                })),
            };
        case 'SET_AP_INFO':
            return { ...state, editAPInfo: action.payload };
        case 'SET_REGISTRATION_MODE':
            return {
                ...state,
                registrationMode: action.payload,
            };
        case 'SET_STORE_STATUS':
            return {
                ...state,
                registrationMode: action.payload,
                loadingState: {
                    ...state.loadingState,
                    storeStateLoading: false,
                },
            };
        case 'SET_STORE_DEVICE_TOTAL':
            return { ...state, storeDeviceTotal: action.payload };
        case 'SET_INFRA_DEVICES':
            return { ...state, infraDevice: action.payload };
        case 'SET_SEARCH_MAC':
            return { ...state, searchMac: action.payload };
        case 'SET_AP_LOCK_INFO':
            return { ...state, apLockInfo: action.payload };
        case 'TOGGLE_DIALOG':
            return {
                ...state,
                dialogState: {
                    ...state.dialogState,
                    [action.payload.dialog]: action.payload.isOpen,
                },
            };
        case 'TOGGLE_LOADING':
            return {
                ...state,
                loadingState: {
                    ...state.loadingState,
                    [action.payload.key]: action.payload.isLoading,
                },
            };
        case 'SET_TAB':
            return {
                ...state,
                currentTab: action.payload,
            };
        case 'SET_INIT_TABLE_STATE':
            return {
                ...state,
                sortModel: { field: null, sort: null },
                paginationModel: { page: 0, pageSize: 5 },
                infraDeviceInfoTable: [],
                selectedInfraDevices: [],
            };
        case 'SET_TABLE_STATE':
            return {
                ...state,
                deviceInfoState: {
                    ...state.deviceInfoState,
                    ...action.payload,
                    isLoading: action.payload.status === 'loading',
                },
            };
        case 'SET_TAG_STATUS':
            return {
                ...state,
                tagStatus: action.payload,
            };
        case 'SET_TAG':
            return {
                ...state,
                tagState: {
                    ...state.tagState,
                    ...action.payload,
                },
            };
        case 'CLEAR':
            return defaultState;
        default:
            return state;
    }
};
